import Bsa from "../../../jsx/components/Dashboard/BSA/bsa";

const BsaWrapper = () => {
  return <Bsa />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.underwriter];
export default constore(BsaWrapper);
